import { Link } from 'react-router-dom';

export function NotFoundRoute() {
  return (
    <main className="not-found">
      <div className="not-found__inner">
        <h1>404</h1>
        <p>This page doesn't exist on chat.channel.tel.</p>
        <Link to="/">Back to landing</Link>
      </div>
    </main>
  );
}
